import React, { MouseEvent } from 'react';
import styled from 'styled-components';
import PhotoGroup from '../../assets/promos/photoGroup.png';
import {
  BottomModalContainer, ModalCloseContainer,
  ModalContainer,
  ModalHeader,
  ModalTitle,
  Overlay,
  TransparentOverlayBottomModal
} from '../../components/modals/CommonModal';
import { DesktopShow, MobileShow } from '../../components/styled/Common';
import { IUEvent } from '../../lib/event';
import CloseIcon from 'Common/src/components/icons/CloseIcon';
import AppStoreDownload from '../../components/icons/AppStoreDownload';
import GooglePlayStoreDownload from '../../components/icons/GooglePlayStoreDownload';
import { WideWhiteButton } from '../../components/buttons/WhiteButton';

const PostRsvpModal = ({ close, event, afterLogin }: {
  close: () => void,
  event: IUEvent,
  afterLogin?: boolean
}) => {
  const handleDownloadShineiOSClick = () => {
    window.open('https://apps.apple.com/us/app/sunshine-photos/id6469663904?itsct=apps_box_badge&amp;itscg=30200',
      '_blank');
  };

  const handleDownloadShineAndroidClick = () => {
    window.open('https://play.google.com/store/apps/details?id=com.lumilabs.android.shine.ga', '_blank');
  };

  const onModalClick = (e: MouseEvent) => {
    e.stopPropagation();
  };

  const titleText = afterLogin ? 'You\'re signed in' : 'RSVP received';
  const subtitleText = <>Join the shared photo stream for <strong>{event?.title ?? 'your event'}.</strong> Download the
    Shine app today!</>;

  const modalContent = <>
    <CardBody>
      <ModalCloseContainer onClick={close}><CloseIcon/></ModalCloseContainer>
      <ModalHeader $hasClose={true}>
        <ModalTitle>{titleText}</ModalTitle>
      </ModalHeader>
      <TextWrapper>
        {subtitleText}
      </TextWrapper>
      <Image src={PhotoGroup}/>
      <StoreIcons>
        <AppLink onClick={handleDownloadShineiOSClick}>
          <AppStoreDownload size={40}/>
        </AppLink>
        <AppLink onClick={handleDownloadShineAndroidClick}>
          <GooglePlayStoreDownload size={40}/>
        </AppLink>
      </StoreIcons>
    </CardBody>
    <ButtonWrapper>
      <WideWhiteButton onClick={close} $invert={true}>
        I already have Shine!
      </WideWhiteButton>
    </ButtonWrapper>
  </>;

  return <>
    <DesktopShow>
      <Overlay onMouseDown={close}>
        <ModalContainer onMouseDown={onModalClick} $smallerGap={true}>
          {modalContent}
        </ModalContainer>
      </Overlay>
    </DesktopShow>
    <MobileShow>
      <TransparentOverlayBottomModal onClick={close}>
        <BottomModalContainer onClick={onModalClick}>
          {modalContent}
        </BottomModalContainer>
      </TransparentOverlayBottomModal>
    </MobileShow>
  </>;
};

const CardBody = styled.div`
  display: flex;
  flex-direction: column;
  gap: 13px;
  width: 100%;
  align-items: center;
`;

const TextWrapper = styled.div``;

const ButtonWrapper = styled.div`
  width: 100%;
  display: flex;
  gap: 20px;
`;

const Image = styled.img`
  width: 50%;
`;

const StoreIcons = styled.div`
  display: flex;
  gap: 24px;
`;

const AppLink = styled.span`
  cursor: pointer;
`;

export default PostRsvpModal;

